require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 0);
}([function (e, t, r) {
  e.exports = r(1);
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var n = function (e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }(r(2));

  t["default"] = n["default"];
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var n = r(3),
      o = function (e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }(r(4));

  t["default"] = function () {
    return {
      handleReturn: function handleReturn(e, t, r) {
        var u = r.setEditorState;

        if ((0, o["default"])(e)) {
          var i = t.getSelection();
          if (i.isCollapsed()) u(n.RichUtils.insertSoftNewline(t));else {
            var f = t.getCurrentContent(),
                l = n.Modifier.removeRange(f, i, "forward"),
                a = l.getSelectionAfter(),
                d = l.getBlockForKey(a.getStartKey());
            l = n.Modifier.insertText(l, a, "\n", d.getInlineStyleAt(a.getStartOffset()), null), u(n.EditorState.push(t, l, "insert-fragment"));
          }
          return "handled";
        }

        return "not-handled";
      }
    };
  };
}, function (e, t) {
  e.exports = require("draft-js");
}, function (e, t) {
  e.exports = require("draft-js/lib/isSoftNewlineEvent");
}]);